import React from 'react';

const Accessibility: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 text-left">
      <h1 className="text-3xl font-bold mb-4">Accessibility Statement</h1>
      <p className="text-gray-700 mb-6">We are committed to making our website accessible to as many people as possible.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Measures to support accessibility</h2>
      <ul className="list-disc ml-6 space-y-2">
        <li>Responsive design and semantic HTML.</li>
        <li>Keyboard navigable components where feasible.</li>
        <li>Contrast-aware design.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Feedback</h2>
      <p className="mb-4">If you experience accessibility barriers, please let us know at our contact page so we can improve.</p>
    </div>
  );
};

export default Accessibility;





